import {
	Dialog,
	Toolbar
} from "client/Components";
import { generateTrackingId } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useState } from "react";
import styles from "./StepKindSelectionDialog.module.less";
import { useDataInputDialog } from "client/Hooks";
import { SelectionCard } from "./SelectionCard";
import { StepKind } from "client/Api/IntegrationBuilder/integrationBuilderFlows";
import { RequestStepKind } from "./common";

export type StepKindSelectionDialogProps = {
	onSelect: (stepKind: RequestStepKind) => void;
	onClose: () => void;
};

export const StepKindSelectionDialog = (props: StepKindSelectionDialogProps): ReactElement => {
	const {
		onSelect,
		onClose
	} = props;

	const [stepKind, setStepKind] = useState<RequestStepKind>(StepKind.Request);

	return (
		<Dialog
			trackingId="integration-builder-step-kind-selection-dialog"
			onClose={onClose}
		>
			<Dialog.Header
				title={localize("_SelectStepType")}
				onClose={onClose}
			/>
			<Dialog.Body>
				<ul className={styles.list}>
					{cardsToRender.map(
						(card: CardData): ReactElement => (
							<li
								key={card.stepKind}
								className={styles.item}
							>
								<SelectionCard
									title={localize(card.title)}
									description={localize(card.description)}
									isSelected={stepKind === card.stepKind}
									onClick={() => setStepKind(card.stepKind)}
									onDoubleClick={() => onSelect(card.stepKind)}
									trackingId={generateTrackingId("step-kind", `|${card.stepKind}`)}
								/>
							</li>
						)
					)}
				</ul>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						trackingId="choose-step-kind"
						text={localize("_ChooseType")}
						kind="primary"
						onClick={() => onSelect(stepKind)}
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
StepKindSelectionDialog.displayName = "StepKindSelectionDialog";

type CardData = {
	stepKind: RequestStepKind;
	title: LocalizationKey;
	description: LocalizationKey;
};

const cardsToRender: readonly CardData[] = [
	{
		stepKind: StepKind.Request,
		title: "_StandardStep",
		description: "_RunsASingleRequestOrAction"
	},
	{
		stepKind: StepKind.PerItemRequest,
		title: "_PerItemStep",
		description: "_RunsARequestForEachItemInACollectionFromAPreviousStep"
	}
];

type RequestStepKindSelectionDialogInitialData = Omit<StepKindSelectionDialogProps, "onClose" | "onSelect">;

export function useStepKindSelectionDialog(): [
	element: ReactElement | null,
	open: (props: RequestStepKindSelectionDialogInitialData) => Promise<TryResult<RequestStepKind>>
] {
	return useDataInputDialog(
		(props, onClose, onSelect) => (
			<StepKindSelectionDialog
				{...props}
				onClose={onClose}
				onSelect={onSelect}
			/>
		)
	);
}
